"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderByDirection = exports.ComparisonType = exports.DataType = exports.VoucherColumns = exports.ResponseType = exports.TableColumnType = exports.ChartTableDataColumnType = exports.ChartType = exports.ChartRateState = exports.RedeemVoucherState = exports.ContractStatus = exports.Operator = exports.UnifiedOperationState = exports.GoogleSubscriptionNotificationType = exports.GoogleOneTimeNotificationType = exports.IntroductoryOfferType = exports.CancellationReason = exports.PaymentType = exports.PurchaseSourceType = exports.ProductType = exports.PurchaseType = exports.PurchaseSource = exports.PlanPermission = exports.ResponseCode = exports.Payment_PromoCodeAlias_Client = exports.Payment_Analytics_Client = exports.Payment_Vouchers_Client = exports.Payment_Tamara_Client = exports.Payment_Stripe_Client = exports.Payment_STCPay_Client = exports.Payment_Moyasar_Client = exports.Payment_MondiaPay_Client = exports.Payment_MobiMind_Client = exports.Payment_MobilePayment_Client = exports.Payment_MediaWorld_Client = exports.Payment_Countries_Client = exports.Payment_BehaviourEvent_Client = exports.Payment_WebHooks_Client = exports.Payment_WebHook_Client = exports.Payment_Unified_Client = exports.Payment_Test_Client = exports.Payment_PromoCode_Client = exports.Payment_Products_Client = exports.Payment_ProductGroup_Client = exports.Payment_PriceTemplates_Client = exports.Payment_Plans_Client = exports.Payment_OfferCodeGroup_Client = exports.Payment_Languages_Client = exports.Payment_Gifts_Client = exports.Payment_Features_Client = void 0;
exports.ApiException = exports.XAppPlatform7 = exports.XAppPlatform6 = exports.XAppPlatform5 = exports.XAppPlatform4 = exports.XAppPlatform3 = exports.XAppPlatform2 = exports.XAppPlatform = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var axios_1 = __importDefault(require("axios"));
var Payment_Features_Client = /** @class */ (function () {
    function Payment_Features_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new feature (Auth policies: 6.1) (Scope: Dashboard)
     */
    Payment_Features_Client.prototype.features_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeatures_post_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processFeatures_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existing feature (Auth policies: 6.2) (Scope: Dashboard)
     */
    Payment_Features_Client.prototype.features_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeatures_put_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processFeatures_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all features (Auth policies: 6.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Features_Client.prototype.features_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeatures_get_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processFeatures_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete feature (Auth policies: 6.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Payment_Features_Client.prototype.features_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFeatures_delete_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processFeatures_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get feature by id (Auth policies: 6.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Features_Client.prototype.id_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get features by plan id (Auth policies: 6.5) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param planId (optional)
     */
    Payment_Features_Client.prototype.byPlan_V1 = function (x_app_language_id, planId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features/by-plan?";
        if (planId === null)
            throw new Error("The parameter 'planId' cannot be null.");
        else if (planId !== undefined)
            url_ += "PlanId=" + encodeURIComponent("" + planId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByPlan_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processByPlan_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get free plan features (Auth policies: 6.5) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Features_Client.prototype.byFreePlan_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features/by-free-plan";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByFreePlan_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processByFreePlan_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign feature to plan (Auth policies: 6.6) (Scope: Dashboard)
     */
    Payment_Features_Client.prototype.assign_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssign_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processAssign_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * UnAssign feature to plan (Auth policies: 6.7) (Scope: Dashboard)
     */
    Payment_Features_Client.prototype.unassign_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Features/unassign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnassign_V1(_response);
        });
    };
    Payment_Features_Client.prototype.processUnassign_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Features_Client;
}());
exports.Payment_Features_Client = Payment_Features_Client;
var Payment_Gifts_Client = /** @class */ (function () {
    function Payment_Gifts_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all customer gifts (Auth policies: 72.1) (Scope: Mobile)
     */
    Payment_Gifts_Client.prototype.gifts_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_get_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processGifts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get available customer gifts (Auth policies: 72.10) (Scope: Mobile)
     */
    Payment_Gifts_Client.prototype.received_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/received";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReceived_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processReceived_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get available customer gifts (Auth policies: 72.2) (Scope: Mobile)
     */
    Payment_Gifts_Client.prototype.available_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/available";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAvailable_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processAvailable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get consumed customer gifts (Auth policies: 72.3) (Scope: Mobile)
     */
    Payment_Gifts_Client.prototype.consumed_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/consumed";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processConsumed_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processConsumed_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Consume a gift using its code (Auth policies: 72.0) (Scope: Mobile)
     */
    Payment_Gifts_Client.prototype.consume_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/consume";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processConsume_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processConsume_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Receive a gift using its code (Auth policies: 72.11) (Scope: Mobile)
     */
    Payment_Gifts_Client.prototype.receive_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/receive";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReceive_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processReceive_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * check a gift using its code (Auth policies: 72.4) (Scope: Mobile)
     * @param code (optional)
     */
    Payment_Gifts_Client.prototype.checkToken_V1 = function (code, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Gifts/check-token?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCheckToken_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processCheckToken_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get bought gifts (Auth policies: 72.5) (Scope: Dashboard)
     * @param customerId (optional)
     */
    Payment_Gifts_Client.prototype.gifts_bought_V1 = function (customerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts/bought?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_bought_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processGifts_bought_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get consumed gifts (Auth policies: 72.6) (Scope: Dashboard)
     * @param customerId (optional)
     */
    Payment_Gifts_Client.prototype.gifts_consumed_V1 = function (customerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts/consumed?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_consumed_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processGifts_consumed_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Consume a gift using its code (Auth policies: 72.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Gifts_Client.prototype.gifts_consume_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts/consume";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_consume_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processGifts_consume_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create gift for a user (Auth policies: 72.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Gifts_Client.prototype.gifts_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processGifts_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get gift by id (Auth policies: 72.9) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param giftId (optional)
     */
    Payment_Gifts_Client.prototype.gifts_byId_V1 = function (x_app_language_id, giftId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Gifts/by-id?";
        if (giftId === null)
            throw new Error("The parameter 'giftId' cannot be null.");
        else if (giftId !== undefined)
            url_ += "GiftId=" + encodeURIComponent("" + giftId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_byId_V1(_response);
        });
    };
    Payment_Gifts_Client.prototype.processGifts_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Gifts_Client;
}());
exports.Payment_Gifts_Client = Payment_Gifts_Client;
var Payment_Languages_Client = /** @class */ (function () {
    function Payment_Languages_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new language (Auth policies: 24.1) (Scope: Dashboard)
     * @param input new language
     */
    Payment_Languages_Client.prototype.languages_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Languages";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLanguages_post_V1(_response);
        });
    };
    Payment_Languages_Client.prototype.processLanguages_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit language (Auth policies: 24.2) (Scope: Dashboard)
     */
    Payment_Languages_Client.prototype.languages_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Languages";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLanguages_put_V1(_response);
        });
    };
    Payment_Languages_Client.prototype.processLanguages_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all languages (Auth policies: 24.0) (Scope: Dashboard; Mobile)
     */
    Payment_Languages_Client.prototype.languages_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Languages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLanguages_get_V1(_response);
        });
    };
    Payment_Languages_Client.prototype.processLanguages_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete language (Auth policies: 24.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Payment_Languages_Client.prototype.languages_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Languages?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLanguages_delete_V1(_response);
        });
    };
    Payment_Languages_Client.prototype.processLanguages_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Languages_Client;
}());
exports.Payment_Languages_Client = Payment_Languages_Client;
var Payment_OfferCodeGroup_Client = /** @class */ (function () {
    function Payment_OfferCodeGroup_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create New Promo Code (Auth policies: 65.1) (Scope: Dashboard)
     * @param groupId (optional)
     * @param expiry (optional)
     * @param promoCodeId (optional)
     * @param productId (optional)
     * @param priceTemplateId (optional)
     * @param offerCodes (optional)
     */
    Payment_OfferCodeGroup_Client.prototype.offerCodeGroup_post_V1 = function (groupId, expiry, promoCodeId, productId, priceTemplateId, offerCodes, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/OfferCodeGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (groupId !== null && groupId !== undefined)
            content_.append("GroupId", groupId.toString());
        if (expiry === null || expiry === undefined)
            throw new Error("The parameter 'expiry' cannot be null.");
        else
            content_.append("Expiry", expiry.toString());
        if (promoCodeId === null || promoCodeId === undefined)
            throw new Error("The parameter 'promoCodeId' cannot be null.");
        else
            content_.append("PromoCodeId", promoCodeId.toString());
        if (productId === null || productId === undefined)
            throw new Error("The parameter 'productId' cannot be null.");
        else
            content_.append("ProductId", productId.toString());
        if (priceTemplateId === null || priceTemplateId === undefined)
            throw new Error("The parameter 'priceTemplateId' cannot be null.");
        else
            content_.append("PriceTemplateId", priceTemplateId.toString());
        if (offerCodes !== null && offerCodes !== undefined)
            content_.append("OfferCodes", offerCodes.data, offerCodes.fileName ? offerCodes.fileName : "OfferCodes");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOfferCodeGroup_post_V1(_response);
        });
    };
    Payment_OfferCodeGroup_Client.prototype.processOfferCodeGroup_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all promo codes (Auth policies: 65.2) (Scope: Dashboard)
     */
    Payment_OfferCodeGroup_Client.prototype.offerCodeGroup_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/OfferCodeGroup";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOfferCodeGroup_get_V1(_response);
        });
    };
    Payment_OfferCodeGroup_Client.prototype.processOfferCodeGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get default offer codes by promo code (Auth policies: 65.3) (Scope: Dashboard)
     * @param code (optional)
     * @param countryId (optional)
     * @param countryCode (optional)
     */
    Payment_OfferCodeGroup_Client.prototype.defaultByPromoCode_V1 = function (code, countryId, countryCode, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/OfferCodeGroup/default-by-promo-code?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (countryId !== undefined && countryId !== null)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDefaultByPromoCode_V1(_response);
        });
    };
    Payment_OfferCodeGroup_Client.prototype.processDefaultByPromoCode_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_OfferCodeGroup_Client;
}());
exports.Payment_OfferCodeGroup_Client = Payment_OfferCodeGroup_Client;
var Payment_Plans_Client = /** @class */ (function () {
    function Payment_Plans_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new plan (Auth policies: 2.1) (Scope: Dashboard)
     */
    Payment_Plans_Client.prototype.plans_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_post_V1(_response);
        });
    };
    Payment_Plans_Client.prototype.processPlans_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existing plan (Auth policies: 2.2) (Scope: Dashboard)
     */
    Payment_Plans_Client.prototype.plans_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_put_V1(_response);
        });
    };
    Payment_Plans_Client.prototype.processPlans_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all plans (Auth policies: 2.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Plans_Client.prototype.plans_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_get_V1(_response);
        });
    };
    Payment_Plans_Client.prototype.processPlans_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete plan (Auth policies: 2.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Payment_Plans_Client.prototype.plans_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_delete_V1(_response);
        });
    };
    Payment_Plans_Client.prototype.processPlans_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My plans (Auth policies: 2.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Plans_Client.prototype.customer_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/customer";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCustomer_V1(_response);
        });
    };
    Payment_Plans_Client.prototype.processCustomer_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get plan by id (Auth policies: 2.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Plans_Client.prototype.id_V12 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V12(_response);
        });
    };
    Payment_Plans_Client.prototype.processId_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set the plan as the free plan (Auth policies: 2.5) (Scope: Dashboard)
     */
    Payment_Plans_Client.prototype.setAsFree_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Plans/set-as-free";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetAsFree_V1(_response);
        });
    };
    Payment_Plans_Client.prototype.processSetAsFree_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Customer plans (Auth policies: 2.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param customerId (optional)
     */
    Payment_Plans_Client.prototype.plans_customer_V1 = function (x_app_language_id, customerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Plans/customer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlans_customer_V1(_response);
        });
    };
    Payment_Plans_Client.prototype.processPlans_customer_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Plans_Client;
}());
exports.Payment_Plans_Client = Payment_Plans_Client;
var Payment_PriceTemplates_Client = /** @class */ (function () {
    function Payment_PriceTemplates_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new apple price template (Auth policies: 3.1) (Scope: Dashboard)
     * @param name (optional)
     * @param discoutAmount (optional)
     * @param productId (optional)
     * @param pricesFile (optional)
     */
    Payment_PriceTemplates_Client.prototype.apple_V1 = function (name, discoutAmount, productId, pricesFile, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PriceTemplates/apple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (discoutAmount === null || discoutAmount === undefined)
            throw new Error("The parameter 'discoutAmount' cannot be null.");
        else
            content_.append("DiscoutAmount", discoutAmount.toString());
        if (productId === null || productId === undefined)
            throw new Error("The parameter 'productId' cannot be null.");
        else
            content_.append("ProductId", productId.toString());
        if (pricesFile !== null && pricesFile !== undefined)
            content_.append("PricesFile", pricesFile.data, pricesFile.fileName ? pricesFile.fileName : "PricesFile");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processApple_V1(_response);
        });
    };
    Payment_PriceTemplates_Client.prototype.processApple_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existng price template (Auth policies: 3.2) (Scope: Dashboard)
     */
    Payment_PriceTemplates_Client.prototype.priceTemplates_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PriceTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPriceTemplates_put_V1(_response);
        });
    };
    Payment_PriceTemplates_Client.prototype.processPriceTemplates_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all price templates (Auth policies: 3.0) (Scope: Dashboard)
     */
    Payment_PriceTemplates_Client.prototype.priceTemplates_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PriceTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPriceTemplates_get_V1(_response);
        });
    };
    Payment_PriceTemplates_Client.prototype.processPriceTemplates_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_PriceTemplates_Client;
}());
exports.Payment_PriceTemplates_Client = Payment_PriceTemplates_Client;
var Payment_ProductGroup_Client = /** @class */ (function () {
    function Payment_ProductGroup_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create New Product Group (Auth policies: 62.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_ProductGroup_Client.prototype.productGroup_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_post_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processProductGroup_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all product Groups (Auth policies: 62.2) (Scope: Dashboard)
     */
    Payment_ProductGroup_Client.prototype.productGroup_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProductGroup_get_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processProductGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get default product group with its products (Auth policies: 62.6) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara)
     */
    Payment_ProductGroup_Client.prototype.default_V1 = function (x_app_language_id, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/default";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDefault_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processDefault_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get gifts product group with its products (Auth policies: 62.9) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara)
     */
    Payment_ProductGroup_Client.prototype.gifts_V1 = function (x_app_language_id, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/gifts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGifts_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processGifts_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get product group with its products by promo code (Auth policies: 62.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara)
     * @param code (optional)
     */
    Payment_ProductGroup_Client.prototype.byPromoCode_V1 = function (x_app_language_id, x_app_platform, code, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/by-promo-code?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByPromoCode_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processByPromoCode_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Default Product Group (Auth policies: 62.3) (Scope: Dashboard)
     */
    Payment_ProductGroup_Client.prototype.setDefault_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/set-default";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetDefault_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processSetDefault_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Gifts Product Group (Auth policies: 62.3) (Scope: Dashboard)
     */
    Payment_ProductGroup_Client.prototype.setGift_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/set-gift";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetGift_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processSetGift_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign Product To Product Group (Auth policies: 62.4) (Scope: Dashboard)
     */
    Payment_ProductGroup_Client.prototype.assignProduct_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/assign-product";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssignProduct_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processAssignProduct_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * UnAssign Product From Product Group (Auth policies: 62.5) (Scope: Dashboard)
     */
    Payment_ProductGroup_Client.prototype.unAssignProduct_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/ProductGroup/un-assign-product";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnAssignProduct_V1(_response);
        });
    };
    Payment_ProductGroup_Client.prototype.processUnAssignProduct_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_ProductGroup_Client;
}());
exports.Payment_ProductGroup_Client = Payment_ProductGroup_Client;
var Payment_Products_Client = /** @class */ (function () {
    function Payment_Products_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new product (Auth policies: 4.1) (Scope: Dashboard)
     */
    Payment_Products_Client.prototype.products_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_post_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processProducts_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit product (Auth policies: 4.2) (Scope: Dashboard)
     */
    Payment_Products_Client.prototype.products_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_put_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processProducts_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all products (Auth policies: 4.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Products_Client.prototype.products_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_get_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processProducts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Product By SKU (Auth policies: 4.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara)
     * @param sKU (optional)
     */
    Payment_Products_Client.prototype.bySku_V1 = function (x_app_language_id, x_app_platform, sKU, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/by-sku?";
        if (sKU !== undefined && sKU !== null)
            url_ += "SKU=" + encodeURIComponent("" + sKU) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBySku_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processBySku_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get plan products (Auth policies: 4.4) (Scope: Dashboard)
     * @param planId (optional)
     */
    Payment_Products_Client.prototype.getByPlan_V1 = function (planId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/get-by-plan?";
        if (planId === null)
            throw new Error("The parameter 'planId' cannot be null.");
        else if (planId !== undefined)
            url_ += "PlanId=" + encodeURIComponent("" + planId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetByPlan_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processGetByPlan_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get products by product group (Auth policies: 4.5) (Scope: Dashboard)
     * @param productGroupId (optional)
     */
    Payment_Products_Client.prototype.getByGroup_V1 = function (productGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/get-by-group?";
        if (productGroupId === null)
            throw new Error("The parameter 'productGroupId' cannot be null.");
        else if (productGroupId !== undefined)
            url_ += "ProductGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetByGroup_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processGetByGroup_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get products by the default group (Auth policies: 4.6) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara)
     */
    Payment_Products_Client.prototype.getDefaultGroup_V1 = function (x_app_language_id, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/get-default-group";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetDefaultGroup_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processGetDefaultGroup_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get public products (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara)
     */
    Payment_Products_Client.prototype.public_V1 = function (x_app_language_id, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/public";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublic_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processPublic_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get products by the given promo code (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara)
     * @param code (optional)
     */
    Payment_Products_Client.prototype.getByPromoCode_V1 = function (x_app_language_id, x_app_platform, code, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/get-by-promo-code?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetByPromoCode_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processGetByPromoCode_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add Customer Product (Auth policies: 4.9) (Scope: Dashboard)
     */
    Payment_Products_Client.prototype.addCustomerProduct_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/add-customer-product";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddCustomerProduct_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processAddCustomerProduct_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Expire Customer Product (Auth policies: 4.10) (Scope: Dashboard)
     */
    Payment_Products_Client.prototype.expireCustomerProduct_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Products/expire-customer-product";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processExpireCustomerProduct_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processExpireCustomerProduct_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Product By purchase source and product type (Auth policies: 4.11) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param purchaseSource (optional)
     * @param productType (optional)
     */
    Payment_Products_Client.prototype.products_customerCareProducts_V1 = function (x_app_language_id, purchaseSource, productType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/customer-care-products?";
        if (purchaseSource !== undefined && purchaseSource !== null)
            url_ += "PurchaseSource=" + encodeURIComponent("" + purchaseSource) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_customerCareProducts_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processProducts_customerCareProducts_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Customer Subscription History (Auth policies: 4.12) (Scope: Dashboard)
     * @param customerId (optional)
     */
    Payment_Products_Client.prototype.products_subscriptionHistory_V1 = function (customerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/subscription-history?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_subscriptionHistory_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processProducts_subscriptionHistory_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Product By purchase source (Auth policies: 4.13) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param source (optional)
     */
    Payment_Products_Client.prototype.products_byPurchaseSource_V1 = function (x_app_language_id, source, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Products/by-purchase-source?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProducts_byPurchaseSource_V1(_response);
        });
    };
    Payment_Products_Client.prototype.processProducts_byPurchaseSource_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Products_Client;
}());
exports.Payment_Products_Client = Payment_Products_Client;
var Payment_PromoCode_Client = /** @class */ (function () {
    function Payment_PromoCode_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create New Promo Code (Auth policies: 63.1) (Scope: Dashboard)
     * @param code (optional)
     */
    Payment_PromoCode_Client.prototype.promoCode_post_V1 = function (code, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (code !== null && code !== undefined)
            content_.append("Code", code.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCode_post_V1(_response);
        });
    };
    Payment_PromoCode_Client.prototype.processPromoCode_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all promo codes (Auth policies: 63.2) (Scope: Dashboard)
     */
    Payment_PromoCode_Client.prototype.promoCode_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCode_get_V1(_response);
        });
    };
    Payment_PromoCode_Client.prototype.processPromoCode_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign Promo Code To Product Group (Auth policies: 63.3) (Scope: Dashboard)
     */
    Payment_PromoCode_Client.prototype.assignProductGroup_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCode/assign-product-group";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssignProductGroup_V1(_response);
        });
    };
    Payment_PromoCode_Client.prototype.processAssignProductGroup_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_PromoCode_Client;
}());
exports.Payment_PromoCode_Client = Payment_PromoCode_Client;
var Payment_Test_Client = /** @class */ (function () {
    function Payment_Test_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    Payment_Test_Client.prototype.log_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/log";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLog_V1(_response);
        });
    };
    Payment_Test_Client.prototype.processLog_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Payment_Test_Client.prototype.test_get_V1 = function (number, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_get_V1(_response);
        });
    };
    Payment_Test_Client.prototype.processTest_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 19.1)
     * @param id (optional)
     */
    Payment_Test_Client.prototype.rehandle_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/base/v1/Test/rehandle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRehandle_V1(_response);
        });
    };
    Payment_Test_Client.prototype.processRehandle_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Test_Client;
}());
exports.Payment_Test_Client = Payment_Test_Client;
var Payment_Unified_Client = /** @class */ (function () {
    function Payment_Unified_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get unified operation by user id, if user id == null then get all (Scope: Dashboard)
     * @param userId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Payment_Unified_Client.prototype.unified_get_V1 = function (userId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Unified?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnified_get_V1(_response);
        });
    };
    Payment_Unified_Client.prototype.processUnified_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get latest unified operation by user id (Auth policies: 7.1) (Scope: Dashboard)
     * @param userId (optional)
     */
    Payment_Unified_Client.prototype.latest_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Unified/latest?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLatest_V1(_response);
        });
    };
    Payment_Unified_Client.prototype.processLatest_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get latest unified operation for the current user (Auth policies: 7.2) (Scope: Dashboard)
     */
    Payment_Unified_Client.prototype.myLatest_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Unified/my-latest";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyLatest_V1(_response);
        });
    };
    Payment_Unified_Client.prototype.processMyLatest_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Unified_Client;
}());
exports.Payment_Unified_Client = Payment_Unified_Client;
var Payment_WebHook_Client = /** @class */ (function () {
    function Payment_WebHook_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: Dashboard)
     */
    Payment_WebHook_Client.prototype.webHook_post_V1 = function (pushBody, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/WebHook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(pushBody);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebHook_post_V1(_response);
        });
    };
    Payment_WebHook_Client.prototype.processWebHook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_WebHook_Client;
}());
exports.Payment_WebHook_Client = Payment_WebHook_Client;
var Payment_WebHooks_Client = /** @class */ (function () {
    function Payment_WebHooks_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Auth) (Scope: Dashboard)
     * @param api_version (optional)
     */
    Payment_WebHooks_Client.prototype.apple_notify_V1 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/purchase/apple/notify?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processApple_notify_V1(_response);
        });
    };
    Payment_WebHooks_Client.prototype.processApple_notify_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param api_version (optional)
     */
    Payment_WebHooks_Client.prototype.apple_V12 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/notification/apple?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processApple_V12(_response);
        });
    };
    Payment_WebHooks_Client.prototype.processApple_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: Dashboard)
     * @param api_version (optional)
     */
    Payment_WebHooks_Client.prototype.payment_purchase_google_notify_V1 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/purchase/google/notify?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPayment_purchase_google_notify_V1(_response);
        });
    };
    Payment_WebHooks_Client.prototype.processPayment_purchase_google_notify_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param api_version (optional)
     */
    Payment_WebHooks_Client.prototype.payment_notification_google_V1 = function (input, api_version, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/notification/google?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPayment_notification_google_V1(_response);
        });
    };
    Payment_WebHooks_Client.prototype.processPayment_notification_google_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_WebHooks_Client;
}());
exports.Payment_WebHooks_Client = Payment_WebHooks_Client;
var Payment_BehaviourEvent_Client = /** @class */ (function () {
    function Payment_BehaviourEvent_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add New Behaviour Event (Auth) (Scope: Dashboard)
     */
    Payment_BehaviourEvent_Client.prototype.behaviourEvent_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/BehaviourEvent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBehaviourEvent_post_V1(_response);
        });
    };
    Payment_BehaviourEvent_Client.prototype.processBehaviourEvent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_BehaviourEvent_Client;
}());
exports.Payment_BehaviourEvent_Client = Payment_BehaviourEvent_Client;
var Payment_Countries_Client = /** @class */ (function () {
    function Payment_Countries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new country (Auth policies: 5.1) (Scope: Dashboard)
     */
    Payment_Countries_Client.prototype.countries_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountries_post_V1(_response);
        });
    };
    Payment_Countries_Client.prototype.processCountries_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existing country (Auth policies: 5.2) (Scope: Dashboard)
     */
    Payment_Countries_Client.prototype.countries_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountries_put_V1(_response);
        });
    };
    Payment_Countries_Client.prototype.processCountries_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all countries (Auth policies: 5.0) (Scope: Dashboard)
     */
    Payment_Countries_Client.prototype.countries_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountries_get_V1(_response);
        });
    };
    Payment_Countries_Client.prototype.processCountries_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get country by price and product id (Auth policies: 5.4) (Scope: Dashboard)
     * @param purchaseProviderKey (optional)
     * @param price (optional)
     */
    Payment_Countries_Client.prototype.byPriceAndProduct_V1 = function (purchaseProviderKey, price, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries/by-price-and-product?";
        if (purchaseProviderKey !== undefined && purchaseProviderKey !== null)
            url_ += "PurchaseProviderKey=" + encodeURIComponent("" + purchaseProviderKey) + "&";
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "Price=" + encodeURIComponent("" + price) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByPriceAndProduct_V1(_response);
        });
    };
    Payment_Countries_Client.prototype.processByPriceAndProduct_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * set exchange currency rate (Auth policies: 5.5) (Scope: Dashboard)
     */
    Payment_Countries_Client.prototype.setExchangeRate_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Countries/set-exchange-rate";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetExchangeRate_V1(_response);
        });
    };
    Payment_Countries_Client.prototype.processSetExchangeRate_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Countries_Client;
}());
exports.Payment_Countries_Client = Payment_Countries_Client;
var Payment_MediaWorld_Client = /** @class */ (function () {
    function Payment_MediaWorld_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_MediaWorld_Client.prototype.sendPinCode_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MediaWorld/send-pin-code";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSendPinCode_V1(_response);
        });
    };
    Payment_MediaWorld_Client.prototype.processSendPinCode_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: ThirdPartyService)
     */
    Payment_MediaWorld_Client.prototype.sendMyPinCode_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MediaWorld/send-my-pin-code";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSendMyPinCode_V1(_response);
        });
    };
    Payment_MediaWorld_Client.prototype.processSendMyPinCode_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_MediaWorld_Client.prototype.verifyPinCode_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MediaWorld/verify-pin-code";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVerifyPinCode_V1(_response);
        });
    };
    Payment_MediaWorld_Client.prototype.processVerifyPinCode_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 114.0) (Scope: ThirdPartyService)
     */
    Payment_MediaWorld_Client.prototype.unsubscribe_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MediaWorld/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnsubscribe_V1(_response);
        });
    };
    Payment_MediaWorld_Client.prototype.processUnsubscribe_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     * @param mSISDN (optional)
     */
    Payment_MediaWorld_Client.prototype.getVoucher_V1GET = function (mSISDN, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MediaWorld/get-voucher?";
        if (mSISDN !== undefined && mSISDN !== null)
            url_ += "MSISDN=" + encodeURIComponent("" + mSISDN) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetVoucher_V1GET(_response);
        });
    };
    Payment_MediaWorld_Client.prototype.processGetVoucher_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     * @param userName (optional)
     * @param password (optional)
     * @param mSISDN (optional)
     * @param actionType (optional)
     * @param serviceId (optional)
     * @param sPID (optional)
     * @param date (optional)
     * @param requestId (optional)
     * @param sC (optional) short code
     * @param key (optional)
     */
    Payment_MediaWorld_Client.prototype.webhook_V1GET = function (userName, password, mSISDN, actionType, serviceId, sPID, date, requestId, sC, key, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MediaWorld/webhook?";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (password !== undefined && password !== null)
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        if (mSISDN !== undefined && mSISDN !== null)
            url_ += "MSISDN=" + encodeURIComponent("" + mSISDN) + "&";
        if (actionType === null)
            throw new Error("The parameter 'actionType' cannot be null.");
        else if (actionType !== undefined)
            url_ += "ActionType=" + encodeURIComponent("" + actionType) + "&";
        if (serviceId !== undefined && serviceId !== null)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sPID !== undefined && sPID !== null)
            url_ += "SPID=" + encodeURIComponent("" + sPID) + "&";
        if (date !== undefined && date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        if (sC !== undefined && sC !== null)
            url_ += "SC=" + encodeURIComponent("" + sC) + "&";
        if (key !== undefined && key !== null)
            url_ += "Key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhook_V1GET(_response);
        });
    };
    Payment_MediaWorld_Client.prototype.processWebhook_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_MediaWorld_Client;
}());
exports.Payment_MediaWorld_Client = Payment_MediaWorld_Client;
var Payment_MobilePayment_Client = /** @class */ (function () {
    function Payment_MobilePayment_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create contract in Tpay dashboard with new status and send PIN code to mobile number (Scope: Mobile)
     */
    Payment_MobilePayment_Client.prototype.create_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreate_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processCreate_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Resend the PIN code again to mobile (Scope: Mobile)
     */
    Payment_MobilePayment_Client.prototype.resend_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/resend";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processResend_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processResend_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Verify the contract using the PIN code and change Subscription contract status in Tpay dashboard to Active if PIN code correct? (Scope: Mobile)
     */
    Payment_MobilePayment_Client.prototype.verify_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/verify";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVerify_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processVerify_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 107.0) (Scope: Mobile)
     */
    Payment_MobilePayment_Client.prototype.contract_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/contract";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContract_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processContract_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Cancelling the contract from the authorized user whom is using this contract (Auth policies: 107.1) (Scope: Mobile)
     */
    Payment_MobilePayment_Client.prototype.cancel_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/cancel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCancel_V1POST(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processCancel_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Another cancelation way but with PIN code to verify the customer that canceling the contract (this way used if the cancelation URL is shared for all customers) (Scope: Mobile)
     */
    Payment_MobilePayment_Client.prototype.requestCancel_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/request-cancel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRequestCancel_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processRequestCancel_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Verification of above cancelation API using the PIN code CancelSubscriptionContractRequest (Scope: Mobile)
     */
    Payment_MobilePayment_Client.prototype.verifyCancel_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/verify-cancel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVerifyCancel_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processVerifyCancel_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get the js library used to prevent froud (Scope: Mobile)
     * @param date (optional)
     */
    Payment_MobilePayment_Client.prototype.getLibrary_V1 = function (date, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/get-library?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetLibrary_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processGetLibrary_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param action (optional)
     */
    Payment_MobilePayment_Client.prototype.webhook_V1GET2 = function (action, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/webhook?";
        if (action !== undefined && action !== null)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhook_V1GET2(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processWebhook_V1GET2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param action (optional)
     * @param subscriptionContractId (optional)
     * @param customerAccountNumber (optional)
     * @param status (optional)
     * @param reason (optional)
     * @param digest (optional)
     */
    Payment_MobilePayment_Client.prototype.webhookStatusChanged_V1 = function (action, subscriptionContractId, customerAccountNumber, status, reason, digest, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/webhook-status-changed?";
        if (action !== undefined && action !== null)
            url_ += "Action=" + encodeURIComponent("" + action) + "&";
        if (subscriptionContractId !== undefined && subscriptionContractId !== null)
            url_ += "SubscriptionContractId=" + encodeURIComponent("" + subscriptionContractId) + "&";
        if (customerAccountNumber !== undefined && customerAccountNumber !== null)
            url_ += "CustomerAccountNumber=" + encodeURIComponent("" + customerAccountNumber) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (reason !== undefined && reason !== null)
            url_ += "Reason=" + encodeURIComponent("" + reason) + "&";
        if (digest !== undefined && digest !== null)
            url_ += "Digest=" + encodeURIComponent("" + digest) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhookStatusChanged_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processWebhookStatusChanged_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param action (optional)
     * @param subscriptionContractId (optional)
     * @param customerAccountNumber (optional)
     * @param paymentTransactionStatusCode (optional)
     * @param transactionId (optional)
     * @param amountCharged (optional)
     * @param currencyCode (optional)
     * @param paymentDate (optional)
     * @param nextPaymentDate (optional)
     * @param errorMessage (optional)
     * @param productCatalogName (optional)
     * @param productId (optional)
     * @param billNumber (optional)
     * @param billAction (optional)
     * @param mSISDN (optional)
     * @param billAmount (optional)
     * @param collectedAmount (optional)
     * @param digest (optional)
     */
    Payment_MobilePayment_Client.prototype.webhookChargingNotification_V1 = function (action, subscriptionContractId, customerAccountNumber, paymentTransactionStatusCode, transactionId, amountCharged, currencyCode, paymentDate, nextPaymentDate, errorMessage, productCatalogName, productId, billNumber, billAction, mSISDN, billAmount, collectedAmount, digest, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobilePayment/webhook-charging-notification?";
        if (action !== undefined && action !== null)
            url_ += "Action=" + encodeURIComponent("" + action) + "&";
        if (subscriptionContractId !== undefined && subscriptionContractId !== null)
            url_ += "SubscriptionContractId=" + encodeURIComponent("" + subscriptionContractId) + "&";
        if (customerAccountNumber !== undefined && customerAccountNumber !== null)
            url_ += "CustomerAccountNumber=" + encodeURIComponent("" + customerAccountNumber) + "&";
        if (paymentTransactionStatusCode !== undefined && paymentTransactionStatusCode !== null)
            url_ += "PaymentTransactionStatusCode=" + encodeURIComponent("" + paymentTransactionStatusCode) + "&";
        if (transactionId !== undefined && transactionId !== null)
            url_ += "TransactionId=" + encodeURIComponent("" + transactionId) + "&";
        if (amountCharged !== undefined && amountCharged !== null)
            url_ += "AmountCharged=" + encodeURIComponent("" + amountCharged) + "&";
        if (currencyCode !== undefined && currencyCode !== null)
            url_ += "CurrencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (paymentDate !== undefined && paymentDate !== null)
            url_ += "PaymentDate=" + encodeURIComponent("" + paymentDate) + "&";
        if (nextPaymentDate !== undefined && nextPaymentDate !== null)
            url_ += "NextPaymentDate=" + encodeURIComponent("" + nextPaymentDate) + "&";
        if (errorMessage !== undefined && errorMessage !== null)
            url_ += "ErrorMessage=" + encodeURIComponent("" + errorMessage) + "&";
        if (productCatalogName !== undefined && productCatalogName !== null)
            url_ += "ProductCatalogName=" + encodeURIComponent("" + productCatalogName) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (billNumber !== undefined && billNumber !== null)
            url_ += "BillNumber=" + encodeURIComponent("" + billNumber) + "&";
        if (billAction !== undefined && billAction !== null)
            url_ += "BillAction=" + encodeURIComponent("" + billAction) + "&";
        if (mSISDN !== undefined && mSISDN !== null)
            url_ += "MSISDN=" + encodeURIComponent("" + mSISDN) + "&";
        if (billAmount !== undefined && billAmount !== null)
            url_ += "BillAmount=" + encodeURIComponent("" + billAmount) + "&";
        if (collectedAmount !== undefined && collectedAmount !== null)
            url_ += "CollectedAmount=" + encodeURIComponent("" + collectedAmount) + "&";
        if (digest !== undefined && digest !== null)
            url_ += "Digest=" + encodeURIComponent("" + digest) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhookChargingNotification_V1(_response);
        });
    };
    Payment_MobilePayment_Client.prototype.processWebhookChargingNotification_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_MobilePayment_Client;
}());
exports.Payment_MobilePayment_Client = Payment_MobilePayment_Client;
var Payment_MobiMind_Client = /** @class */ (function () {
    function Payment_MobiMind_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: ThirdPartyService)
     * @param user (optional)
     * @param password (optional)
     * @param channelId (optional)
     * @param operatorId (optional)
     * @param requestId (optional)
     * @param mSISDN (optional)
     * @param status (optional)
     */
    Payment_MobiMind_Client.prototype.webhook_V1GET3 = function (user, password, channelId, operatorId, requestId, mSISDN, status, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobiMind/webhook?";
        if (user !== undefined && user !== null)
            url_ += "User=" + encodeURIComponent("" + user) + "&";
        if (password !== undefined && password !== null)
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "ChannelId=" + encodeURIComponent("" + channelId) + "&";
        if (operatorId === null)
            throw new Error("The parameter 'operatorId' cannot be null.");
        else if (operatorId !== undefined)
            url_ += "OperatorId=" + encodeURIComponent("" + operatorId) + "&";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        if (mSISDN !== undefined && mSISDN !== null)
            url_ += "MSISDN=" + encodeURIComponent("" + mSISDN) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhook_V1GET3(_response);
        });
    };
    Payment_MobiMind_Client.prototype.processWebhook_V1GET3 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     * @param mSISDN (optional)
     */
    Payment_MobiMind_Client.prototype.getVoucher_V1GET2 = function (mSISDN, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobiMind/get-voucher?";
        if (mSISDN !== undefined && mSISDN !== null)
            url_ += "MSISDN=" + encodeURIComponent("" + mSISDN) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetVoucher_V1GET2(_response);
        });
    };
    Payment_MobiMind_Client.prototype.processGetVoucher_V1GET2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_MobiMind_Client.prototype.branchEvent_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MobiMind/branch-event";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBranchEvent_V1(_response);
        });
    };
    Payment_MobiMind_Client.prototype.processBranchEvent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_MobiMind_Client;
}());
exports.Payment_MobiMind_Client = Payment_MobiMind_Client;
var Payment_MondiaPay_Client = /** @class */ (function () {
    function Payment_MondiaPay_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.preparePurchase_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/prepare-purchase";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPreparePurchase_V1(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processPreparePurchase_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.prepareMyPurchase_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/prepare-my-purchase";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPrepareMyPurchase_V1(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processPrepareMyPurchase_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.getVoucher_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/get-voucher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetVoucher_V1POST(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processGetVoucher_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 113.0) (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.cancel_V1DELETE = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/cancel";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCancel_V1DELETE(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processCancel_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.webhook_V1POST = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/webhook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhook_V1POST(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processWebhook_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.publicCreateSubscription_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/public-create-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublicCreateSubscription_V1(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processPublicCreateSubscription_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.createSubscription_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/create-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateSubscription_V1(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processCreateSubscription_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.publicConfirmSubscription_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/public-confirm-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublicConfirmSubscription_V1(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processPublicConfirmSubscription_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: ThirdPartyService)
     */
    Payment_MondiaPay_Client.prototype.confirmSubscription_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/MondiaPay/confirm-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processConfirmSubscription_V1(_response);
        });
    };
    Payment_MondiaPay_Client.prototype.processConfirmSubscription_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_MondiaPay_Client;
}());
exports.Payment_MondiaPay_Client = Payment_MondiaPay_Client;
var Payment_Moyasar_Client = /** @class */ (function () {
    function Payment_Moyasar_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: ThirdPartyService)
     * @param secret_token (optional)
     */
    Payment_Moyasar_Client.prototype.webhook_V1POST2 = function (secret_token, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Moyasar/webhook?";
        if (secret_token !== undefined && secret_token !== null)
            url_ += "secret_token=" + encodeURIComponent("" + secret_token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhook_V1POST2(_response);
        });
    };
    Payment_Moyasar_Client.prototype.processWebhook_V1POST2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_Moyasar_Client.prototype.initiatePayment_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Moyasar/initiate-payment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInitiatePayment_V1(_response);
        });
    };
    Payment_Moyasar_Client.prototype.processInitiatePayment_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth) (Scope: ThirdPartyService)
     */
    Payment_Moyasar_Client.prototype.initiateMyPayment_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Moyasar/initiate-my-payment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInitiateMyPayment_V1(_response);
        });
    };
    Payment_Moyasar_Client.prototype.processInitiateMyPayment_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: ThirdPartyService)
     */
    Payment_Moyasar_Client.prototype.getVoucher_V1POST2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Moyasar/get-voucher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetVoucher_V1POST2(_response);
        });
    };
    Payment_Moyasar_Client.prototype.processGetVoucher_V1POST2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Moyasar_Client;
}());
exports.Payment_Moyasar_Client = Payment_Moyasar_Client;
var Payment_STCPay_Client = /** @class */ (function () {
    function Payment_STCPay_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create contract in STCPay dashboard with new status and send PIN code to mobile number (Scope: Mobile)
     */
    Payment_STCPay_Client.prototype.create_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/STCPay/create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreate_V12(_response);
        });
    };
    Payment_STCPay_Client.prototype.processCreate_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create contract in STCPay dashboard with new status and send PIN code to mobile number (Auth) (Scope: Mobile)
     */
    Payment_STCPay_Client.prototype.createMy_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/STCPay/create-my";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateMy_V1(_response);
        });
    };
    Payment_STCPay_Client.prototype.processCreateMy_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Verify the contract using the PIN code and change Subscription contract status in STCPay dashboard to Active if PIN code correct? (Scope: Mobile)
     */
    Payment_STCPay_Client.prototype.verify_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/STCPay/verify";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVerify_V12(_response);
        });
    };
    Payment_STCPay_Client.prototype.processVerify_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_STCPay_Client;
}());
exports.Payment_STCPay_Client = Payment_STCPay_Client;
var Payment_Stripe_Client = /** @class */ (function () {
    function Payment_Stripe_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create Stripe Checkout session with (Scope: Mobile)
     * @param redirectLink (optional)
     * @param lookupKey (optional)
     * @param email (optional)
     * @param clickId (optional)
     */
    Payment_Stripe_Client.prototype.createCheckoutSession_V1 = function (redirectLink, lookupKey, email, clickId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/create-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (redirectLink !== null && redirectLink !== undefined)
            content_.append("RedirectLink", redirectLink.toString());
        if (lookupKey !== null && lookupKey !== undefined)
            content_.append("LookupKey", lookupKey.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (clickId !== null && clickId !== undefined)
            content_.append("ClickId", clickId.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateCheckoutSession_V1(_response);
        });
    };
    Payment_Stripe_Client.prototype.processCreateCheckoutSession_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * create my stripe checkout session (Auth) (Scope: Mobile)
     */
    Payment_Stripe_Client.prototype.createMyCheckoutSession_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/create-my-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateMyCheckoutSession_V1(_response);
        });
    };
    Payment_Stripe_Client.prototype.processCreateMyCheckoutSession_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * create my stripe payment intent (Auth) (Scope: Mobile)
     */
    Payment_Stripe_Client.prototype.createMyPaymentIntent_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/create-my-payment-intent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateMyPaymentIntent_V1(_response);
        });
    };
    Payment_Stripe_Client.prototype.processCreateMyPaymentIntent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Voucher By Stripe Session Checkout (Scope: Mobile)
     * @param checkoutSessionToken (optional)
     */
    Payment_Stripe_Client.prototype.getVoucherBySession_V1 = function (checkoutSessionToken, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/get-voucher-by-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (checkoutSessionToken !== null && checkoutSessionToken !== undefined)
            content_.append("CheckoutSessionToken", checkoutSessionToken.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetVoucherBySession_V1(_response);
        });
    };
    Payment_Stripe_Client.prototype.processGetVoucherBySession_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Cancel Subscription (Auth) (Scope: Mobile)
     */
    Payment_Stripe_Client.prototype.cancellation_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/cancellation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCancellation_V1(_response);
        });
    };
    Payment_Stripe_Client.prototype.processCancellation_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    Payment_Stripe_Client.prototype.webhook_V1POST3 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Stripe/webhook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhook_V1POST3(_response);
        });
    };
    Payment_Stripe_Client.prototype.processWebhook_V1POST3 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Stripe_Client;
}());
exports.Payment_Stripe_Client = Payment_Stripe_Client;
var Payment_Tamara_Client = /** @class */ (function () {
    function Payment_Tamara_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create Checkout session (Scope: Mobile)
     */
    Payment_Tamara_Client.prototype.createCheckoutSession_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Tamara/create-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateCheckoutSession_V12(_response);
        });
    };
    Payment_Tamara_Client.prototype.processCreateCheckoutSession_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * create my  checkout session (Auth) (Scope: Mobile)
     */
    Payment_Tamara_Client.prototype.createMyCheckoutSession_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Tamara/create-my-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateMyCheckoutSession_V12(_response);
        });
    };
    Payment_Tamara_Client.prototype.processCreateMyCheckoutSession_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param tamaraToken (optional)
     */
    Payment_Tamara_Client.prototype.webhook_V1POST4 = function (tamaraToken, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Tamara/webhook?";
        if (tamaraToken !== undefined && tamaraToken !== null)
            url_ += "tamaraToken=" + encodeURIComponent("" + tamaraToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebhook_V1POST4(_response);
        });
    };
    Payment_Tamara_Client.prototype.processWebhook_V1POST4 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Tamara_Client;
}());
exports.Payment_Tamara_Client = Payment_Tamara_Client;
var Payment_Vouchers_Client = /** @class */ (function () {
    function Payment_Vouchers_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Redeem Voucher (Auth policies: 87.3) (Scope: Mobile)
     */
    Payment_Vouchers_Client.prototype.redeem_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Vouchers/redeem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRedeem_V1(_response);
        });
    };
    Payment_Vouchers_Client.prototype.processRedeem_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Check Voucher Validity for User (Auth policies: 87.4) (Scope: Mobile)
     */
    Payment_Vouchers_Client.prototype.checkValidity_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/Vouchers/check-validity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCheckValidity_V1(_response);
        });
    };
    Payment_Vouchers_Client.prototype.processCheckValidity_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Voucher (Auth policies: 87.1) (Scope: Dashboard)
     */
    Payment_Vouchers_Client.prototype.vouchers_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVouchers_V1POST(_response);
        });
    };
    Payment_Vouchers_Client.prototype.processVouchers_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Voucher (Auth policies: 87.2) (Scope: Dashboard)
     */
    Payment_Vouchers_Client.prototype.vouchers_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVouchers_V1PUT(_response);
        });
    };
    Payment_Vouchers_Client.prototype.processVouchers_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Voucher Publication (Auth policies: 87.5) (Scope: Dashboard)
     */
    Payment_Vouchers_Client.prototype.vouchers_publish_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/publish";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVouchers_publish_V1(_response);
        });
    };
    Payment_Vouchers_Client.prototype.processVouchers_publish_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Voucher By Id (Auth policies: 87.6) (Scope: Dashboard)
     * @param id (optional)
     */
    Payment_Vouchers_Client.prototype.vouchers_byId_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVouchers_byId_V1(_response);
        });
    };
    Payment_Vouchers_Client.prototype.processVouchers_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Voucher By Voucher Code (Auth policies: 87.7) (Scope: Dashboard)
     * @param code (optional)
     */
    Payment_Vouchers_Client.prototype.vouchers_byCode_V1 = function (code, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/by-code?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVouchers_byCode_V1(_response);
        });
    };
    Payment_Vouchers_Client.prototype.processVouchers_byCode_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Voucher Datatable (Auth policies: 87.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Payment_Vouchers_Client.prototype.vouchers_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Vouchers/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVouchers_datatable_V1(_response);
        });
    };
    Payment_Vouchers_Client.prototype.processVouchers_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Vouchers_Client;
}());
exports.Payment_Vouchers_Client = Payment_Vouchers_Client;
var Payment_Analytics_Client = /** @class */ (function () {
    function Payment_Analytics_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get  Number Of Purchases Per Operator for Mobimind (Auth policies: 117.1) (Scope: Mobile; Dashboard)
     */
    Payment_Analytics_Client.prototype.analytics_getNumberOfPurchasesPerOperatorForMobimind_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/admin/Analytics/get-number-of-purchases-per-operator-for-mobimind";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_getNumberOfPurchasesPerOperatorForMobimind_V1(_response);
        });
    };
    Payment_Analytics_Client.prototype.processAnalytics_getNumberOfPurchasesPerOperatorForMobimind_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_Analytics_Client;
}());
exports.Payment_Analytics_Client = Payment_Analytics_Client;
var Payment_PromoCodeAlias_Client = /** @class */ (function () {
    function Payment_PromoCodeAlias_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create New Promo Code Alias (Auth policies: 116.1) (Scope: Dashboard)
     */
    Payment_PromoCodeAlias_Client.prototype.promoCodeAlias_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPromoCodeAlias_post_V1(_response);
        });
    };
    Payment_PromoCodeAlias_Client.prototype.processPromoCodeAlias_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * publish promo Code Alias (Auth policies: 116.2) (Scope: Dashboard)
     */
    Payment_PromoCodeAlias_Client.prototype.publication_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias/publication";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublication_V1(_response);
        });
    };
    Payment_PromoCodeAlias_Client.prototype.processPublication_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * update promo Code Alias expiration (Auth policies: 116.3) (Scope: Dashboard)
     */
    Payment_PromoCodeAlias_Client.prototype.update_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/payment/v1/PromoCodeAlias/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdate_V1(_response);
        });
    };
    Payment_PromoCodeAlias_Client.prototype.processUpdate_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Payment_PromoCodeAlias_Client;
}());
exports.Payment_PromoCodeAlias_Client = Payment_PromoCodeAlias_Client;
/** 0 = Success 400 = BadRequest 403 = Forbidden 404 = NotFound 404 = UserNotFound 404 = RoleNotFound 404 = RoleClaimNotFound 405 = Unauthorized 406 = NotAcceptable 407 = MaxNumberOfSimultaneousLogins 410 = DeletionNotAllowed 411 = AlreadyExist 412 = InvalidEmail 413 = InvalidCode 414 = EmailTaken 415 = UserBlocked 416 = InvalidCredentials 417 = InvalidPassword 500 = InternalServerError */
var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["Success"] = 0] = "Success";
    ResponseCode[ResponseCode["BadRequest"] = 400] = "BadRequest";
    ResponseCode[ResponseCode["Forbidden"] = 403] = "Forbidden";
    ResponseCode[ResponseCode["NotFound"] = 404] = "NotFound";
    ResponseCode[ResponseCode["UserNotFound"] = 404] = "UserNotFound";
    ResponseCode[ResponseCode["RoleNotFound"] = 404] = "RoleNotFound";
    ResponseCode[ResponseCode["RoleClaimNotFound"] = 404] = "RoleClaimNotFound";
    ResponseCode[ResponseCode["Unauthorized"] = 405] = "Unauthorized";
    ResponseCode[ResponseCode["NotAcceptable"] = 406] = "NotAcceptable";
    ResponseCode[ResponseCode["MaxNumberOfSimultaneousLogins"] = 407] = "MaxNumberOfSimultaneousLogins";
    ResponseCode[ResponseCode["DeletionNotAllowed"] = 410] = "DeletionNotAllowed";
    ResponseCode[ResponseCode["AlreadyExist"] = 411] = "AlreadyExist";
    ResponseCode[ResponseCode["InvalidEmail"] = 412] = "InvalidEmail";
    ResponseCode[ResponseCode["InvalidCode"] = 413] = "InvalidCode";
    ResponseCode[ResponseCode["EmailTaken"] = 414] = "EmailTaken";
    ResponseCode[ResponseCode["UserBlocked"] = 415] = "UserBlocked";
    ResponseCode[ResponseCode["InvalidCredentials"] = 416] = "InvalidCredentials";
    ResponseCode[ResponseCode["InvalidPassword"] = 417] = "InvalidPassword";
    ResponseCode[ResponseCode["InternalServerError"] = 500] = "InternalServerError";
})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
/** 0 = None 1 = Download 2 = Next 4 = Back 8 = FastForward 16 = FastBackward 32 = Seek 64 = Read 128 = Highlight 256 = Bookmark 512 = Playlists 1024 = ChapterList 2048 = Gifts */
var PlanPermission;
(function (PlanPermission) {
    PlanPermission[PlanPermission["None"] = 0] = "None";
    PlanPermission[PlanPermission["Download"] = 1] = "Download";
    PlanPermission[PlanPermission["Next"] = 2] = "Next";
    PlanPermission[PlanPermission["Back"] = 4] = "Back";
    PlanPermission[PlanPermission["FastForward"] = 8] = "FastForward";
    PlanPermission[PlanPermission["FastBackward"] = 16] = "FastBackward";
    PlanPermission[PlanPermission["Seek"] = 32] = "Seek";
    PlanPermission[PlanPermission["Read"] = 64] = "Read";
    PlanPermission[PlanPermission["Highlight"] = 128] = "Highlight";
    PlanPermission[PlanPermission["Bookmark"] = 256] = "Bookmark";
    PlanPermission[PlanPermission["Playlists"] = 512] = "Playlists";
    PlanPermission[PlanPermission["ChapterList"] = 1024] = "ChapterList";
    PlanPermission[PlanPermission["Gifts"] = 2048] = "Gifts";
})(PlanPermission = exports.PlanPermission || (exports.PlanPermission = {}));
/** 0 = APPLE 1 = HUAWEI 2 = GOOGLE 3 = OFFLINE 4 = INTERNAL 5 = FREE 6 = VOUCHER 7 = STRIPE 8 = TPAY 10 = MONDIAPAY_VODAFONE 11 = MONDIAPAY_ETISALAT 12 = MONDIAPAY_ORANGE 13 = MONDIAPAY_WE 14 = STCPay 16 = MOBIMIND_STC 17 = MOBIMIND_MOBILY 18 = MOBIMIND_ZAIN 19 = MOYASAR_APPLE_PAY 20 = MOYASAR_STCPAY 21 = MOYASAR_CREDITCARD 22 = MEDIAWORLD_ZAIN 23 = MEDIAWORLD_JAWWAL 24 = TAMARA */
var PurchaseSource;
(function (PurchaseSource) {
    PurchaseSource[PurchaseSource["APPLE"] = 0] = "APPLE";
    PurchaseSource[PurchaseSource["HUAWEI"] = 1] = "HUAWEI";
    PurchaseSource[PurchaseSource["GOOGLE"] = 2] = "GOOGLE";
    PurchaseSource[PurchaseSource["OFFLINE"] = 3] = "OFFLINE";
    PurchaseSource[PurchaseSource["INTERNAL"] = 4] = "INTERNAL";
    PurchaseSource[PurchaseSource["FREE"] = 5] = "FREE";
    PurchaseSource[PurchaseSource["VOUCHER"] = 6] = "VOUCHER";
    PurchaseSource[PurchaseSource["STRIPE"] = 7] = "STRIPE";
    PurchaseSource[PurchaseSource["TPAY"] = 8] = "TPAY";
    PurchaseSource[PurchaseSource["MONDIAPAY_VODAFONE"] = 10] = "MONDIAPAY_VODAFONE";
    PurchaseSource[PurchaseSource["MONDIAPAY_ETISALAT"] = 11] = "MONDIAPAY_ETISALAT";
    PurchaseSource[PurchaseSource["MONDIAPAY_ORANGE"] = 12] = "MONDIAPAY_ORANGE";
    PurchaseSource[PurchaseSource["MONDIAPAY_WE"] = 13] = "MONDIAPAY_WE";
    PurchaseSource[PurchaseSource["STCPay"] = 14] = "STCPay";
    PurchaseSource[PurchaseSource["MOBIMIND_STC"] = 16] = "MOBIMIND_STC";
    PurchaseSource[PurchaseSource["MOBIMIND_MOBILY"] = 17] = "MOBIMIND_MOBILY";
    PurchaseSource[PurchaseSource["MOBIMIND_ZAIN"] = 18] = "MOBIMIND_ZAIN";
    PurchaseSource[PurchaseSource["MOYASAR_APPLE_PAY"] = 19] = "MOYASAR_APPLE_PAY";
    PurchaseSource[PurchaseSource["MOYASAR_STCPAY"] = 20] = "MOYASAR_STCPAY";
    PurchaseSource[PurchaseSource["MOYASAR_CREDITCARD"] = 21] = "MOYASAR_CREDITCARD";
    PurchaseSource[PurchaseSource["MEDIAWORLD_ZAIN"] = 22] = "MEDIAWORLD_ZAIN";
    PurchaseSource[PurchaseSource["MEDIAWORLD_JAWWAL"] = 23] = "MEDIAWORLD_JAWWAL";
    PurchaseSource[PurchaseSource["TAMARA"] = 24] = "TAMARA";
})(PurchaseSource = exports.PurchaseSource || (exports.PurchaseSource = {}));
/** 0 = SUBSCRIPTION_RENEWABLE 1 = SUBSCRIPTION_NON_RENEWABLE 2 = ONETIME_CONSUMABLE 3 = ONETIME_NONCONSUMABLE 4 = FREE */
var PurchaseType;
(function (PurchaseType) {
    PurchaseType[PurchaseType["SUBSCRIPTION_RENEWABLE"] = 0] = "SUBSCRIPTION_RENEWABLE";
    PurchaseType[PurchaseType["SUBSCRIPTION_NON_RENEWABLE"] = 1] = "SUBSCRIPTION_NON_RENEWABLE";
    PurchaseType[PurchaseType["ONETIME_CONSUMABLE"] = 2] = "ONETIME_CONSUMABLE";
    PurchaseType[PurchaseType["ONETIME_NONCONSUMABLE"] = 3] = "ONETIME_NONCONSUMABLE";
    PurchaseType[PurchaseType["FREE"] = 4] = "FREE";
})(PurchaseType = exports.PurchaseType || (exports.PurchaseType = {}));
/** 0 = SubscriptionProduct 1 = GiftProduct 2 = ContentProduct */
var ProductType;
(function (ProductType) {
    ProductType[ProductType["SubscriptionProduct"] = 0] = "SubscriptionProduct";
    ProductType[ProductType["GiftProduct"] = 1] = "GiftProduct";
    ProductType[ProductType["ContentProduct"] = 2] = "ContentProduct";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
/** 0 = MOBILE_STORE 1 = CARD_DIRECT 2 = INSTALLMENT_PLAN 3 = DCP_WALLET 4 = VOUCHER 5 = FREE 6 = INTERNAL 7 = OFFLINE 10 = Other */
var PurchaseSourceType;
(function (PurchaseSourceType) {
    PurchaseSourceType[PurchaseSourceType["MOBILE_STORE"] = 0] = "MOBILE_STORE";
    PurchaseSourceType[PurchaseSourceType["CARD_DIRECT"] = 1] = "CARD_DIRECT";
    PurchaseSourceType[PurchaseSourceType["INSTALLMENT_PLAN"] = 2] = "INSTALLMENT_PLAN";
    PurchaseSourceType[PurchaseSourceType["DCP_WALLET"] = 3] = "DCP_WALLET";
    PurchaseSourceType[PurchaseSourceType["VOUCHER"] = 4] = "VOUCHER";
    PurchaseSourceType[PurchaseSourceType["FREE"] = 5] = "FREE";
    PurchaseSourceType[PurchaseSourceType["INTERNAL"] = 6] = "INTERNAL";
    PurchaseSourceType[PurchaseSourceType["OFFLINE"] = 7] = "OFFLINE";
    PurchaseSourceType[PurchaseSourceType["Other"] = 10] = "Other";
})(PurchaseSourceType = exports.PurchaseSourceType || (exports.PurchaseSourceType = {}));
/** 0 = Pending 1 = Paid 2 = Refund 3 = Deferred */
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["Pending"] = 0] = "Pending";
    PaymentType[PaymentType["Paid"] = 1] = "Paid";
    PaymentType[PaymentType["Refund"] = 2] = "Refund";
    PaymentType[PaymentType["Deferred"] = 3] = "Deferred";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
/** 0 = User 1 = System 2 = Switch 3 = Developer */
var CancellationReason;
(function (CancellationReason) {
    CancellationReason[CancellationReason["User"] = 0] = "User";
    CancellationReason[CancellationReason["System"] = 1] = "System";
    CancellationReason[CancellationReason["Switch"] = 2] = "Switch";
    CancellationReason[CancellationReason["Developer"] = 3] = "Developer";
})(CancellationReason = exports.CancellationReason || (exports.CancellationReason = {}));
/** 0 = FreeTrial 1 = IntroductoryOffer 2 = OfferCode */
var IntroductoryOfferType;
(function (IntroductoryOfferType) {
    IntroductoryOfferType[IntroductoryOfferType["FreeTrial"] = 0] = "FreeTrial";
    IntroductoryOfferType[IntroductoryOfferType["IntroductoryOffer"] = 1] = "IntroductoryOffer";
    IntroductoryOfferType[IntroductoryOfferType["OfferCode"] = 2] = "OfferCode";
})(IntroductoryOfferType = exports.IntroductoryOfferType || (exports.IntroductoryOfferType = {}));
/** 1 = ONE_TIME_PRODUCT_PURCHASED 2 = ONE_TIME_PRODUCT_CANCELED */
var GoogleOneTimeNotificationType;
(function (GoogleOneTimeNotificationType) {
    GoogleOneTimeNotificationType[GoogleOneTimeNotificationType["ONE_TIME_PRODUCT_PURCHASED"] = 1] = "ONE_TIME_PRODUCT_PURCHASED";
    GoogleOneTimeNotificationType[GoogleOneTimeNotificationType["ONE_TIME_PRODUCT_CANCELED"] = 2] = "ONE_TIME_PRODUCT_CANCELED";
})(GoogleOneTimeNotificationType = exports.GoogleOneTimeNotificationType || (exports.GoogleOneTimeNotificationType = {}));
/** 1 = SUBSCRIPTION_RECOVERED 2 = SUBSCRIPTION_RENEWED 3 = SUBSCRIPTION_CANCELED 4 = SUBSCRIPTION_PURCHASED 5 = SUBSCRIPTION_ON_HOLD 6 = SUBSCRIPTION_IN_GRACE_PERIOD 7 = SUBSCRIPTION_RESTARTED 8 = SUBSCRIPTION_PRICE_CHANGE_CONFIRMED 9 = SUBSCRIPTION_DEFERRED 10 = SUBSCRIPTION_PAUSED 11 = SUBSCRIPTION_PAUSE_SCHEDULE_CHANGED 12 = SUBSCRIPTION_REVOKED 13 = SUBSCRIPTION_EXPIRED */
var GoogleSubscriptionNotificationType;
(function (GoogleSubscriptionNotificationType) {
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_RECOVERED"] = 1] = "SUBSCRIPTION_RECOVERED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_RENEWED"] = 2] = "SUBSCRIPTION_RENEWED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_CANCELED"] = 3] = "SUBSCRIPTION_CANCELED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_PURCHASED"] = 4] = "SUBSCRIPTION_PURCHASED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_ON_HOLD"] = 5] = "SUBSCRIPTION_ON_HOLD";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_IN_GRACE_PERIOD"] = 6] = "SUBSCRIPTION_IN_GRACE_PERIOD";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_RESTARTED"] = 7] = "SUBSCRIPTION_RESTARTED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_PRICE_CHANGE_CONFIRMED"] = 8] = "SUBSCRIPTION_PRICE_CHANGE_CONFIRMED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_DEFERRED"] = 9] = "SUBSCRIPTION_DEFERRED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_PAUSED"] = 10] = "SUBSCRIPTION_PAUSED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_PAUSE_SCHEDULE_CHANGED"] = 11] = "SUBSCRIPTION_PAUSE_SCHEDULE_CHANGED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_REVOKED"] = 12] = "SUBSCRIPTION_REVOKED";
    GoogleSubscriptionNotificationType[GoogleSubscriptionNotificationType["SUBSCRIPTION_EXPIRED"] = 13] = "SUBSCRIPTION_EXPIRED";
})(GoogleSubscriptionNotificationType = exports.GoogleSubscriptionNotificationType || (exports.GoogleSubscriptionNotificationType = {}));
/** 1 = Pending 2 = New 3 = Renew 4 = IntentionToCancel 5 = Canceled 6 = Revoked 7 = GracePeriod 8 = FailedToRenew 9 = RecoverFromFailure 10 = AccountHold */
var UnifiedOperationState;
(function (UnifiedOperationState) {
    UnifiedOperationState[UnifiedOperationState["Pending"] = 1] = "Pending";
    UnifiedOperationState[UnifiedOperationState["New"] = 2] = "New";
    UnifiedOperationState[UnifiedOperationState["Renew"] = 3] = "Renew";
    UnifiedOperationState[UnifiedOperationState["IntentionToCancel"] = 4] = "IntentionToCancel";
    UnifiedOperationState[UnifiedOperationState["Canceled"] = 5] = "Canceled";
    UnifiedOperationState[UnifiedOperationState["Revoked"] = 6] = "Revoked";
    UnifiedOperationState[UnifiedOperationState["GracePeriod"] = 7] = "GracePeriod";
    UnifiedOperationState[UnifiedOperationState["FailedToRenew"] = 8] = "FailedToRenew";
    UnifiedOperationState[UnifiedOperationState["RecoverFromFailure"] = 9] = "RecoverFromFailure";
    UnifiedOperationState[UnifiedOperationState["AccountHold"] = 10] = "AccountHold";
})(UnifiedOperationState = exports.UnifiedOperationState || (exports.UnifiedOperationState = {}));
/** 0 = STC 1 = EAE 2 = Mobily 3 = Zain */
var Operator;
(function (Operator) {
    Operator[Operator["STC"] = 0] = "STC";
    Operator[Operator["EAE"] = 1] = "EAE";
    Operator[Operator["Mobily"] = 2] = "Mobily";
    Operator[Operator["Zain"] = 3] = "Zain";
})(Operator = exports.Operator || (exports.Operator = {}));
/** 0 = New 1 = Active 2 = Suspended 3 = Purged 4 = Canceled 5 = PendingOnCallback */
var ContractStatus;
(function (ContractStatus) {
    ContractStatus[ContractStatus["New"] = 0] = "New";
    ContractStatus[ContractStatus["Active"] = 1] = "Active";
    ContractStatus[ContractStatus["Suspended"] = 2] = "Suspended";
    ContractStatus[ContractStatus["Purged"] = 3] = "Purged";
    ContractStatus[ContractStatus["Canceled"] = 4] = "Canceled";
    ContractStatus[ContractStatus["PendingOnCallback"] = 5] = "PendingOnCallback";
})(ContractStatus = exports.ContractStatus || (exports.ContractStatus = {}));
/** 0 = Pending 1 = Auto */
var RedeemVoucherState;
(function (RedeemVoucherState) {
    RedeemVoucherState[RedeemVoucherState["Pending"] = 0] = "Pending";
    RedeemVoucherState[RedeemVoucherState["Auto"] = 1] = "Auto";
})(RedeemVoucherState = exports.RedeemVoucherState || (exports.RedeemVoucherState = {}));
/** 0 = INCREASE 1 = DECREASE */
var ChartRateState;
(function (ChartRateState) {
    ChartRateState[ChartRateState["INCREASE"] = 0] = "INCREASE";
    ChartRateState[ChartRateState["DECREASE"] = 1] = "DECREASE";
})(ChartRateState = exports.ChartRateState || (exports.ChartRateState = {}));
/** 0 = Line 1 = Area 2 = Bar */
var ChartType;
(function (ChartType) {
    ChartType[ChartType["Line"] = 0] = "Line";
    ChartType[ChartType["Area"] = 1] = "Area";
    ChartType[ChartType["Bar"] = 2] = "Bar";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
/** 0 = Text 1 = Progress 2 = Plan 3 = Number */
var ChartTableDataColumnType;
(function (ChartTableDataColumnType) {
    ChartTableDataColumnType[ChartTableDataColumnType["Text"] = 0] = "Text";
    ChartTableDataColumnType[ChartTableDataColumnType["Progress"] = 1] = "Progress";
    ChartTableDataColumnType[ChartTableDataColumnType["Plan"] = 2] = "Plan";
    ChartTableDataColumnType[ChartTableDataColumnType["Number"] = 3] = "Number";
})(ChartTableDataColumnType = exports.ChartTableDataColumnType || (exports.ChartTableDataColumnType = {}));
/** 0 = Text 1 = Progress 2 = Plan 3 = Number */
var TableColumnType;
(function (TableColumnType) {
    TableColumnType[TableColumnType["Text"] = 0] = "Text";
    TableColumnType[TableColumnType["Progress"] = 1] = "Progress";
    TableColumnType[TableColumnType["Plan"] = 2] = "Plan";
    TableColumnType[TableColumnType["Number"] = 3] = "Number";
})(TableColumnType = exports.TableColumnType || (exports.TableColumnType = {}));
/** 0 = Chart 1 = ChartTable 2 = Stats 3 = Table */
var ResponseType;
(function (ResponseType) {
    ResponseType[ResponseType["Chart"] = 0] = "Chart";
    ResponseType[ResponseType["ChartTable"] = 1] = "ChartTable";
    ResponseType[ResponseType["Stats"] = 2] = "Stats";
    ResponseType[ResponseType["Table"] = 3] = "Table";
})(ResponseType = exports.ResponseType || (exports.ResponseType = {}));
/** 0 = Default 1 = Id 2 = ProductId 4 = Code 8 = UsageLimit 16 = RedeemableBySameUserMoreThanOnce 32 = ExpirationDate 64 = Published 128 = CreatedDate 256 = UpdatedDate */
var VoucherColumns;
(function (VoucherColumns) {
    VoucherColumns[VoucherColumns["Default"] = 0] = "Default";
    VoucherColumns[VoucherColumns["Id"] = 1] = "Id";
    VoucherColumns[VoucherColumns["ProductId"] = 2] = "ProductId";
    VoucherColumns[VoucherColumns["Code"] = 4] = "Code";
    VoucherColumns[VoucherColumns["UsageLimit"] = 8] = "UsageLimit";
    VoucherColumns[VoucherColumns["RedeemableBySameUserMoreThanOnce"] = 16] = "RedeemableBySameUserMoreThanOnce";
    VoucherColumns[VoucherColumns["ExpirationDate"] = 32] = "ExpirationDate";
    VoucherColumns[VoucherColumns["Published"] = 64] = "Published";
    VoucherColumns[VoucherColumns["CreatedDate"] = 128] = "CreatedDate";
    VoucherColumns[VoucherColumns["UpdatedDate"] = 256] = "UpdatedDate";
})(VoucherColumns = exports.VoucherColumns || (exports.VoucherColumns = {}));
/** Types of the data inside columns 0 = String 1 = Guid 2 = Number 3 = Image 4 = Boolean 5 = DateTime 6 = NumberMS 7 = NumberCurrency 8 = Date */
var DataType;
(function (DataType) {
    DataType[DataType["String"] = 0] = "String";
    DataType[DataType["Guid"] = 1] = "Guid";
    DataType[DataType["Number"] = 2] = "Number";
    DataType[DataType["Image"] = 3] = "Image";
    DataType[DataType["Boolean"] = 4] = "Boolean";
    DataType[DataType["DateTime"] = 5] = "DateTime";
    DataType[DataType["NumberMS"] = 6] = "NumberMS";
    DataType[DataType["NumberCurrency"] = 7] = "NumberCurrency";
    DataType[DataType["Date"] = 8] = "Date";
})(DataType = exports.DataType || (exports.DataType = {}));
/** The Comparison type that will be done between the selected column and the criteria 0 = Equal 1 = NotEqual 2 = Contain 3 = Greater 4 = GreaterOrEqual 5 = Less 6 = LessOrEqual 7 = Between */
var ComparisonType;
(function (ComparisonType) {
    ComparisonType[ComparisonType["Equal"] = 0] = "Equal";
    ComparisonType[ComparisonType["NotEqual"] = 1] = "NotEqual";
    ComparisonType[ComparisonType["Contain"] = 2] = "Contain";
    ComparisonType[ComparisonType["Greater"] = 3] = "Greater";
    ComparisonType[ComparisonType["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    ComparisonType[ComparisonType["Less"] = 5] = "Less";
    ComparisonType[ComparisonType["LessOrEqual"] = 6] = "LessOrEqual";
    ComparisonType[ComparisonType["Between"] = 7] = "Between";
})(ComparisonType = exports.ComparisonType || (exports.ComparisonType = {}));
/** The direction of the sorting operation 0 = Ascending 1 = Descending */
var OrderByDirection;
(function (OrderByDirection) {
    OrderByDirection[OrderByDirection["Ascending"] = 0] = "Ascending";
    OrderByDirection[OrderByDirection["Descending"] = 1] = "Descending";
})(OrderByDirection = exports.OrderByDirection || (exports.OrderByDirection = {}));
var XAppPlatform;
(function (XAppPlatform) {
    XAppPlatform["IOS"] = "IOS";
    XAppPlatform["Android"] = "Android";
    XAppPlatform["Web_STCPay"] = "Web_STCPay";
    XAppPlatform["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform["Stripe"] = "Stripe";
    XAppPlatform["Tamara"] = "Tamara";
})(XAppPlatform = exports.XAppPlatform || (exports.XAppPlatform = {}));
var XAppPlatform2;
(function (XAppPlatform2) {
    XAppPlatform2["IOS"] = "IOS";
    XAppPlatform2["Android"] = "Android";
    XAppPlatform2["Web_STCPay"] = "Web_STCPay";
    XAppPlatform2["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform2["Stripe"] = "Stripe";
    XAppPlatform2["Tamara"] = "Tamara";
})(XAppPlatform2 = exports.XAppPlatform2 || (exports.XAppPlatform2 = {}));
var XAppPlatform3;
(function (XAppPlatform3) {
    XAppPlatform3["IOS"] = "IOS";
    XAppPlatform3["Android"] = "Android";
    XAppPlatform3["Web_STCPay"] = "Web_STCPay";
    XAppPlatform3["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform3["Stripe"] = "Stripe";
    XAppPlatform3["Tamara"] = "Tamara";
})(XAppPlatform3 = exports.XAppPlatform3 || (exports.XAppPlatform3 = {}));
var XAppPlatform4;
(function (XAppPlatform4) {
    XAppPlatform4["IOS"] = "IOS";
    XAppPlatform4["Android"] = "Android";
    XAppPlatform4["Web_STCPay"] = "Web_STCPay";
    XAppPlatform4["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform4["Stripe"] = "Stripe";
    XAppPlatform4["Tamara"] = "Tamara";
})(XAppPlatform4 = exports.XAppPlatform4 || (exports.XAppPlatform4 = {}));
var XAppPlatform5;
(function (XAppPlatform5) {
    XAppPlatform5["IOS"] = "IOS";
    XAppPlatform5["Android"] = "Android";
    XAppPlatform5["Web_STCPay"] = "Web_STCPay";
    XAppPlatform5["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform5["Stripe"] = "Stripe";
    XAppPlatform5["Tamara"] = "Tamara";
})(XAppPlatform5 = exports.XAppPlatform5 || (exports.XAppPlatform5 = {}));
var XAppPlatform6;
(function (XAppPlatform6) {
    XAppPlatform6["IOS"] = "IOS";
    XAppPlatform6["Android"] = "Android";
    XAppPlatform6["Web_STCPay"] = "Web_STCPay";
    XAppPlatform6["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform6["Stripe"] = "Stripe";
    XAppPlatform6["Tamara"] = "Tamara";
})(XAppPlatform6 = exports.XAppPlatform6 || (exports.XAppPlatform6 = {}));
var XAppPlatform7;
(function (XAppPlatform7) {
    XAppPlatform7["IOS"] = "IOS";
    XAppPlatform7["Android"] = "Android";
    XAppPlatform7["Web_STCPay"] = "Web_STCPay";
    XAppPlatform7["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform7["Stripe"] = "Stripe";
    XAppPlatform7["Tamara"] = "Tamara";
})(XAppPlatform7 = exports.XAppPlatform7 || (exports.XAppPlatform7 = {}));
function jsonParse(json, reviver) {
    json = JSON.parse(json, reviver);
    var byid = {};
    var refs = [];
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        if ("$ref" in obj) {
            var ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        }
        else if ("$id" in obj) {
            var id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        if (Array.isArray(obj)) {
            obj = obj.map(function (v, i) { return recurse(v, i, obj); });
        }
        else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }
        return obj;
    })(json);
    for (var i = 0; i < refs.length; i++) {
        var ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }
    return json;
}
function createInstance(data, mappings, type) {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;
    var mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target;
    data[mappingIndexName] = mappings.length;
    var result = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
